
import { Grid, Typography, Container, Box, } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import * as React from 'react';
import { FontFamilySwitch } from '../../utils';
const useStyles = makeStyles((theme) => ({
    root: {
        padding: "8px 0px",
        backgroundColor: "white"
    },
    iconBoxStyle: {
        height: "50px",
        width: "50px",
        borderRadius: theme.palette.borderRadius,
        backgroundColor: "#F5F7FA",
        padding: "16px"
    },
    typeStyle: {
        fontSize: "0.75rem",
        color: "#98A0AC",
        fontFamily: FontFamilySwitch().semiBold,
        textAlign: "left",
    },
    valueStyle: {
        fontSize: "0.75rem",
        color: "#091B29",
        fontFamily: FontFamilySwitch().semiBold,
        textAlign: "-webkit-match-parent",
        direction: "ltr"
    },
}))
export const ContactDetails = (props) => {
    const classes = useStyles();


    return (<>
        {props?.data?.map((item) => {
            return (<Container maxWidth="sm" sx={{ padding: 0 }}>
                <Grid
                    container
                    alignItems="center"
                    direction="row"
                    className={classes.root}>
                    <Grid
                        item>
                        <Box className={classes.iconBoxStyle}>
                            <img src={item.type === "Contact Name" ? "/images/icons8_person.svg" : "/images/icons8_call.svg"} alt="altimage" />
                        </Box>
                    </Grid>
                    <Box width="16px" />
                    <Grid
                        item
                        justifyContent="left"
                        direction="column">
                        <Typography
                            className={classes.typeStyle}>
                            {item.type}
                        </Typography>
                        <Box height="6px" />
                        <Typography
                            className={classes.valueStyle}>
                            {item.value}
                        </Typography>
                    </Grid>
                </Grid>
            </Container>);
        })}</>
    );
}
